import React, {Component} from 'react';
import FormGroup from '../FormGroup';
import Input from '../input';
import './resultItem.css';
import EditorComponent from '../Editor';
import RadioGroup from '../radiogroup';
import Button from '../button';
import Checkbox from "../checkbox";
import {FilePond, registerPlugin} from "react-filepond";
import filepondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondImagePreview from "filepond-plugin-image-preview";
import filepondPluginFileEncode from "filepond-plugin-file-encode";

import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

registerPlugin(
    filepondPluginFileValidateType,
    FilePondImagePreview,
    filepondPluginFileEncode
);

class ResultItem extends Component {
    render() {
        return (
            <div className="result-item">
                <h3>Результат № {this.props.index + 1}</h3>
                {this.props.testType === 1 && (
                    <>
                        <FormGroup className="form-group__admin">
                            <Input
                                title="От"
                                type="number"
                                name="intervalFrom"
                                classList="input_number"
                                value={this.props.value.intervalFrom}
                                onChange={this.props.changeValue.bind(this, this.props.index)}
                            />{' '}
                            -{' '}
                            <Input
                                title="До"
                                type="number"
                                name="intervalTo"
                                classList="input_number"
                                value={this.props.value.intervalTo}
                                onChange={this.props.changeValue.bind(this, this.props.index)}
                            />
                            <Input
                                title="Заголовок"
                                name="title"
                                classList="input-result-text"
                                value={this.props.value.title}
                                onChange={this.props.changeValue.bind(this, this.props.index)}
                            />
                        </FormGroup>
                        <FormGroup>
                            <div className="filepond-group">
                                <FilePond
                                    ref={ref => this.pond = ref}
                                    acceptedFileTypes={['image/*']}
                                    allowFileEncode={true}
                                    name={`resultsImage${this.props.index}`}
                                    onaddfile={(error, file) => setTimeout(() => {
                                        this.props.addImageResults(this.props.index, `resultsImage${this.props.index}`)
                                    }, 2000)}
                                />

                                {!this.props.results[this.props.index].imageUrl ? <div/> :
                                    this.props.results[this.props.index].imageUrl.indexOf('base64') === -1 ?
                                        <div className="filepond-img-wrapper">
                                            <div className="filepond-img"><img
                                                src={`https://ppc.world/quizzes/api${this.props.results[this.props.index].imageUrl}`}/>
                                            </div>
                                            <a href="#" className="link"
                                               onClick={(e) => this.props.removeImageResults(e, this.props.index)}>Удалить
                                                изображение</a>
                                        </div> :
                                        <div className="filepond-img-wrapper">
                                            <div className="filepond-img"><img
                                                src={`${this.props.results[this.props.index].imageUrl}`}/></div>
                                            <a href="#" className="link"
                                               onClick={(e) => this.props.removeImageResults(e, this.props.index)}>Удалить
                                                изображение</a>
                                        </div>
                                }
                            </div>
                        </FormGroup>
                    </>
                )}
                {this.props.testType !== 1 && (
                    <>
                        <FormGroup className="form-group__admin">
                            <Input
                                title="Заголовок"
                                name="title"
                                value={this.props.value.title}
                                onChange={this.props.changeValue.bind(this, this.props.index)}
                            />
                        </FormGroup>
                        <FormGroup>
                            <div className="filepond-group">
                                <FilePond
                                    ref={ref => this.pond = ref}
                                    acceptedFileTypes={['image/*']}
                                    allowFileEncode={true}
                                    name={`resultsImage${this.props.index}`}
                                    onaddfile={(error, file) => setTimeout(() => {
                                        this.props.addImageResults(this.props.index, `resultsImage${this.props.index}`)
                                    }, 2000)}
                                />

                                {!this.props.results[this.props.index].imageUrl ? <div/> :
                                    this.props.results[this.props.index].imageUrl.indexOf('base64') === -1 ?
                                        <div className="filepond-img-wrapper">
                                            <div className="filepond-img"><img
                                                src={`https://ppc.world/quizzes/api${this.props.results[this.props.index].imageUrl}`}/>
                                            </div>
                                            <a href="#" className="link"
                                               onClick={(e) => this.props.removeImageResults(e, this.props.index)}>Удалить
                                                изображение</a>
                                        </div> :
                                        <div className="filepond-img-wrapper">
                                            <div className="filepond-img"><img
                                                src={`${this.props.results[this.props.index].imageUrl}`}/></div>
                                            <a href="#" className="link"
                                               onClick={(e) => this.props.removeImageResults(e, this.props.index)}>Удалить
                                                изображение</a>
                                        </div>
                                }
                            </div>
                        </FormGroup>
                        <FormGroup className="form-group__admin">
                            <RadioGroup
                                changeResultGroup={this.props.changeResultGroup}
                                index={this.props.index}
                                activeGroup={this.props.activeGroup}
                                questions={this.props.questions}
                                results={this.props.results}
                                resultList={this.props}
                            />
                        </FormGroup>
                    </>
                )}
                <FormGroup className="form-group__admin">
                    <EditorComponent
                        title="Текст"
                        editorState={this.props.value.comment}
                        onEditorStateChange={this.props.changeCommentResult.bind(
                            this,
                            this.props.index
                        )}
                    />
                </FormGroup>
                <h4>Кнопка для результата</h4>
                <FormGroup className="form-group__admin">
                    <Input
                        title="Текст кнопки"
                        type="text"
                        name="resultButtonText"
                        value={this.props.value.resultButtonText}
                        onChange={this.props.changeResultButtonText.bind(this, this.props.index)}
                    />
                </FormGroup>
                <FormGroup className="form-group__admin">
                    <Input
                        title="Ссылка у кнопки"
                        type="text"
                        name="resultButtonLink"
                        value={this.props.value.resultButtonLink}
                        onChange={this.props.changeResultButtonLink.bind(this, this.props.index)}
                    />
                </FormGroup>
                <FormGroup className="form-group__admin">
                    <Checkbox
                        onChange={this.props.changeLeadForm.bind(
                            this,
                            this.props.index
                        )}
                        checked={this.props.value.isLeadForm}
                        text={`Включить форму`}
                        name="isLeadForm"
                    />
                </FormGroup>
                <FormGroup className="form-group__admin">
                    <Input
                        title="Тег в mailchimp"
                        type="text"
                        name="mailchimpTag"
                        value={this.props.value.mailchimpTag}
                        onChange={this.props.changeMailchimpTag.bind(this, this.props.index)}
                    />
                </FormGroup>
                {this.props.resultList.length !== 1 && (
                    <Button
                        textButton="Удалить"
                        classList="btn_secondary result-item__remove"
                        onClick={this.props.removeResultItem.bind(this.props.index, this)}
                    />
                )}
            </div>
        );
    }
}

export default ResultItem;
